import React from 'react'
import './DescriptionBox.css'

const DescriptionBox = () => {
  return (
    <div className='descriptionbox'>
        <div className="descriptionbox-navigator">
            <div className="descriptionbox-nav-box">
                Description    
            </div>    
            <div className="descriptionbox-nav-box fade">
                Reviews (122)    
            </div>    
        </div>     
        <div className="descriptionbox-description">
            <p>An eCommerce platform is a software solution that allows businesses to create and manage online stores. It provides the necessary tools to handle various aspects of online retail, including product listings, shopping cart functionality, payment processing, inventory management, and customer relationship management. These platforms can vary in complexity, catering to small startups or large enterprises, and often include features such as customizable templates, SEO optimization, and analytics to track performance. By enabling seamless transactions and efficient operations, eCommerce platforms help businesses reach a broader audience and enhance the shopping experience for customers.</p>
            <p>An eCommerce platform is a comprehensive software solution designed to facilitate online buying and selling, enabling businesses to create and manage their online stores effectively. These platforms typically include a range of essential features such as product management, allowing users to easily add, edit, and organize product listings with descriptions, images, and pricing. A user-friendly shopping cart and checkout system are crucial for providing customers with a seamless shopping experience, often supporting guest checkout and various payment gateways for secure transactions.</p>
            
        </div>
    </div>
  )
}

export default DescriptionBox
